import React, { useState } from 'react'
import logo from "../assets/logo.svg"
import { Link, NavLink } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { searchBook } from '../features/filter/filterSlice'

export default function Navbar() {
    const dispatch = useDispatch()
    const [searchValue, setSearchValue] = useState("")

    function handleSearch(e) {
        e.preventDefault();
        dispatch(searchBook(searchValue))
    }

    return (
        <nav class="py-4 2xl:px-6">
            <div class="container flex items-center justify-between">
                <Link to="/"><img src={logo} width="150px" class="object-contain" alt='logo' /></Link>

                <ul class="hidden md:flex items-center space-x-6">
                    <NavLink className={({ isActive, isPending }) => isActive ? "cursor-pointer font-semibold" : "cursor-pointer"} to="/" id="lws-bookStore">
                        <li>Book Store</li>
                    </NavLink>
                    <NavLink
                        className={({ isActive, isPending }) => isActive ? "cursor-pointer font-semibold" : "cursor-pointer"}
                        to="/add-book" id="lws-addBook">
                        <li>Add Book</li>
                    </NavLink>
                </ul>

                <form onSubmit={handleSearch} class="flex items-center">
                    <div class="group relative rounded-md bg-white">
                        <svg width="20" height="20" fill="currentColor"
                            class="absolute left-3 top-1/2 -mt-2.5 text-slate-400 pointer-events-none group-focus-within:text-primary">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z">
                            </path>
                        </svg>
                        <input type="text" placeholder="Filter books..." class="search" id="lws-search" onChange={e => setSearchValue(e.target.value)} value={searchValue} />
                    </div>
                </form>
            </div>
        </nav>
    )
}
